<div class="container">
  <h1>404</h1>

  <h3>Page not found</h3>

  <p class="message">Sorry, we couldn’t find the page you’re looking for.</p>

  <button mat-flat-button color="primary" routerLink="/auth/sign-in">Go back</button>
</div>
